import { useState, type CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import Popup from "src/components/Popup/Popup";
import { getTagStyle } from "src/helpers/randomColor";
import type { Group } from "src/types";

interface Props {
    groups: Group[];
    currentGroupIds: string[];
    onChange: (groupIds: string[]) => void;
    onClose: () => void;
}

export function PatientGroupsPopup({ groups, currentGroupIds, onChange, onClose }: Props) {
    const { t } = useTranslation();
    // Tracked locally so a click reflects instantly instead of waiting on the PATCH + refetch round trip.
    const [selected, setSelected] = useState<Set<string>>(new Set(currentGroupIds));

    const handleClick = (groupId: string) => {
        const next = new Set(selected);
        next.has(groupId) ? next.delete(groupId) : next.add(groupId);
        setSelected(next);
        onChange([...next]);
    };

    return (
        <Popup
            title={t("groups.manageGroups")}
            onClose={onClose}
            actions={[{ label: t("popup.done"), variant: "primary", onClick: onClose }]}
            message={
                groups.length ? (
                    <div className="inv-filter__chips patient-groups-popup__chips">
                        {groups.map((group) => (
                            <button
                                key={group.id}
                                type="button"
                                className={`inv-filter__chip inv-filter__chip--tag${selected.has(group.id) ? " inv-filter__chip--active" : ""}`}
                                style={getTagStyle(group.name) as CSSProperties}
                                onClick={() => handleClick(group.id)}
                            >
                                {group.name}
                            </button>
                        ))}
                    </div>
                ) : (
                    <p className="patient-groups-popup__empty">{t("groups.noGroups")}</p>
                )
            }
        />
    );
}

export default PatientGroupsPopup;
